export default __webpack_public_path__ + "static/media/3.03da06f6.jpg";